import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeSentry, ErrorBoundary } from './config/sentry';

// Initialize Sentry error monitoring (MUST be first)
initializeSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary
      fallback={({ error, componentStack, resetError }) => (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h1>Something went wrong</h1>
          <p>We've been notified of the issue and are working to fix it.</p>
          <button
            onClick={resetError}
            style={{
              marginTop: '1rem',
              padding: '0.5rem 1rem',
              cursor: 'pointer',
              background: '#3B82F6',
              color: 'white',
              border: 'none',
              borderRadius: '0.25rem'
            }}
          >
            Try Again
          </button>
          {process.env.NODE_ENV === 'development' && (
            <details style={{ marginTop: '2rem', textAlign: 'left' }}>
              <summary>Error Details (Dev Only)</summary>
              <pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
                {error.toString()}
                {componentStack}
              </pre>
            </details>
          )}
        </div>
      )}
      showDialog
    >
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
